import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      "Cerca la Prestazione": "Search for a medical visit",
      "Cerca una prestazione": "Search for a medical visit",
      "Si ricorda all’utenza che le prestazioni prenotabili dal CUP sono esclusivamente quelle presenti nell’elenco": "Patients are reminded that appointments made through the CUP (Appointment Call Center) are only those indicated in the list",
      "se preferisci cerca in": "se preferisci cerca in",
      "elenco": "list",
      "Prestazione": "Medical visit",
      "prestazione": "MEDICAL VISIT",
      "Modifica Prestazione": "Change appointment",
      "PRESTAZIONE N": "Medical Visit N",
      "Correttamente registrata, è necessario inserire i dati personali per concludere la richiesta": "Properly registered, it is necessary to include patient’s personal data to complete the request",
      "impegnativa medica": "medical prescription",
      "Inserisci i Dati": "Fill in the information",
      "Data impegnativa": "Date of medical prescription",
      "GG/MM/AAAA": "DD/MM/YYYY",
      "Sei in possesso di una": "Do you have",
      "Impegnativa cartacea": "Printed medical prescription",
      "o di una": "or an",
      "Ricetta elettronica": "Electronic medical prescription",
      "Codice dopo S": "Code after S",
      "Codice dopo Y": "Code after Y",
      "CODICE IMPEGNATIVA": "PRESCRIPTION CODE",
      "NUMERO RICETTA ELETTRONICA": "ELECTRONIC MEDICAL PRESCRIPTION N",
      "NUMERO RICETTA": "MEDICAL PRESCRIPTION N",
      "Motivo della Visita ed Informazioni Aggiuntive": "Purpose of the visit and Additional Info",
      "Continua": "Continue",
      "Attenzione": "Caution",
      "La richiesta di prenotazione non è ancora completata": "The appointment request is not yet completed",
      "Come desideri procedere ora": "How would you like to proceed now",
      "Aggiungi Prestazione": "Add Medical Visit",
      "Inserisci i tuoi dati": "Add your information",
      "Digita il nome della prestazione richiesta": "Insert the medical visit name",
      "dati utente": "user information",
      "Inserisci Dati": "Add Information",
      "Nome": "Name",
      "Cognome": "Last Name",
      "Codice Fiscale": "Fiscal Code",
      "Cellulare": "Cell number",
      "Email": "Email",
      "Recapiti": "Address data",
      "Residenza": "Residence",
      "Conferma Email": "Email confirmation",
      "Indirizzo di residenza": "Residential address",
      "CAP": "ZIP CODE",
      "Comune di residenza": "Municipality of residence",
      "Stato di residenza": "Country of residence",
      "Privacy e Trattamento dei Dati": "Privacy and data processing",
      "Invio di Comunicazioni": "Sending notifications",
      "Preso atto dell'informativa di cui all'art. 13 del GDPR EU 2016/679": "Having taken note of the statement regarding art. 13 del GDPR EU 2016/679",
      "Acconsento al trattamento dei dati personali e relativi allo stato di salute al fine di effettuare la prenotazione della prestazione richiesta": "I hereby give consent to the processing of personal data as well as that related to health conditions in order to make the requested medical visit appointment",
      "Invio tramite email di comunicazioni informative tipo news di servizio e aggiornamento sulle attività del Policlinico Gemelli": "Informational notifications such as service news and updates on Policlinico Gemelli activities sent via e-mail ",
      "Invio tramite SMS di comunicazioni informative tipo news di servizio e aggiornamento sulle attività del Policlinico Gemelli.": "Informational notifications such as service news and updates on Policlinico Gemelli activities sent via SMS",
      "Invia Richiesta": "Send Request",
      "Acconsento": "I Agree",
      "Non Acconsento": "I Do Not Agree",
      "Grazie": "Thank You!",
      "La tua richiesta di prenotazione é stata ricevuta correttamente, un operatore del CUP (Centro Unico Prenotazioni) ti ricontatterà quanto prima": "Your appointment request has been properly received. An Appointment Call Center (CUP) operator will contact you as soon as possible",
      "Scarica se disponibili i documenti informativi in pdf riguardanti la prestazione scelta": "Download, if available, the informational documents in pdf form regarding the medical visit chosen",
      "Questo messaggio è solo una notifica di avvenuta ricezione, non è in nessun modo da considerare come una prenotazione avvenuta": "This message is only a receipt notification. It should not, in any way, be considered as an  appointment",
      "La prenotazione sarà realmente effettiva solo dopo la ricezione della chiamata da parte del CUP": "The appointment will be considered valid only after receiving the call from the Appointment Call Center (CUP)",
      "Centro Unico Prenotazioni": "Appointment Call Center",
      "Alcune note": "Some additional information",
      "Potrà capitare che la chiamata da parte dell'operatore del CUP (Centro Unico Prenotazioni) risulti arrivare da un": "The call from the Appointment Call Center (CUP) operator could come from a private or hidden number, but make sure to answer nonetheless",
      "numero privato": "private number",
      "nascosto": "hidden ",
      "assicurati di rispondere ugualmente": "but make sure to answer nonetheless",
      "Ricordati di disdire la tua prenotazione per tempo se fossi impossibilitato": "Remember to cancel your appointment in time if you are unable to go",
      "Per disdire una prestazione presso il Policlinico Gemelli puoi scrivere un'email all'indirizzo": "To cancel an appointment at Policlinico Gemelli send an e-mail to the following address",
      "chiamare il CUP al numero": "call the CUP at",
      "o inviare un fax al numero": "or send a fax to",
      "Per disdire una prestazione presso il Presidio Columbus puoi scrivere un'email all'indirizzo": "To cancel an appointment at Presidio Columbus send an e-mail to the following address",
      "Inserisci una nuova richiesta": "Add a new request",
      "Dati Personali": "Personal Information",
      "Scegli in quale struttura preferisci effettuare la prestazione": "Facilty selection",
      "Struttura": "Facility",
      "struttura": "facility",
      "Nota Bene": "Please Note",
      "premere il tasto 1 per parlare con un operatore": "press key number 1 to speak with an operator",
      "premere il tasto 2 per parlare con un operatore": "press key number 2 to speak with an operator"

    }
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: window.location.href.includes("/en/") ? "en" : "it",

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });


  export default i18n;